export var STATE_NAME = 'index.customercare.customer.orders.transition';
export var REVIEW_STORE_ORDER_TRANSITION = 'index.customercare.customer.orders.reviewStoreOrderTransition';